export const GET_WHATSAPP_LOGS = 'GET_WHATSAPP_LOGS'
